import type { ReactNode } from 'react';

export const symbol_wifi_proxy: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M700-180h50v-50h-50v50Zm0-110h50v-50h-50v50Zm110 110h50v-50h-50v50Zm-125 60q-18.75 0-31.87-13.13Q640-146.25 640-165v-190q0-18.75 13.13-31.88Q666.25-400 685-400h80q18.75 0 31.88 13.12Q810-373.75 810-355v65h65q18.75 0 31.88 13.12Q920-263.75 920-245v80q0 18.75-13.12 31.87Q893.75-120 875-120H685ZM480-800q120 0 228.5 41T909-644q10.62 8.12 16.31 19.56Q931-613 932-600q1 13-3.81 24.94Q923.37-563.13 913-553l-52 53q-8 8-20.5 8t-20.5-8q-8-8-8-20.5t8-20.5l52-53q-87-68-184.5-107T480-740q-110 0-207.5 39T88-594l392 392 39-39q8-8 20.5-8t20.5 8q8 8 8 20.5t-8 20.5l-38 38q-9 9-20 13t-22 4q-11 0-22-4t-20-13L48-552q-9.75-9.91-14.87-22.49Q28-587.08 29-600.04t6-24.46Q40-636 51-645q92-74 200.5-114.5T480-800Zm0 329Z"
		/>
	</svg>
);
